import { Instance } from 'mobx-state-tree';
import { PlanningActionMetadataReOptimizeDtoModelBase } from './PlanningActionMetadataReOptimizeDtoModel.base';

/* The TypeScript type of an instance of PlanningActionMetadataReOptimizeDtoModel */
export interface PlanningActionMetadataReOptimizeDtoModelType extends Instance<typeof PlanningActionMetadataReOptimizeDtoModel.Type> {}

/* A graphql query fragment builders for PlanningActionMetadataReOptimizeDtoModel */
export { selectFromPlanningActionMetadataReOptimizeDto, planningActionMetadataReOptimizeDtoModelPrimitives, PlanningActionMetadataReOptimizeDtoModelSelector } from './PlanningActionMetadataReOptimizeDtoModel.base';

/**
 * PlanningActionMetadataReOptimizeDtoModel
 */
export const PlanningActionMetadataReOptimizeDtoModel = PlanningActionMetadataReOptimizeDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
